import { getAxiosClient } from '~src/api';
import { changeImageSrc } from '~src/utils';
import { onErrorShowMessage } from '~src/errors';
import { getState } from '~src/state';
import { triggerStateChangedRequest } from '~core';
import { trackEvent } from '~src/tracking';
import { onCompleteAttachment } from '~uploader';
import { FEATURES, isFeatureEnabled } from '~src/features';
import { prepareImageForEditing } from '~core/image';
import { showApprovalDialog } from '~core/ai/dialogs/showApprovalDialog';
import {
  startAiLoader,
  stopAiLoader,
  showAiSuccessMessage,
  AI_FEATURE_LOADING_MESSAGES,
} from '~core/aiLoader';
import { isPlaceholderEditing } from '~core/magicFrame';

export default async function handleAutocolor() {
  const allowUseAutocolor = await isFeatureEnabled(
    FEATURES.AI_USE_AUTOCOLOR,
    false
  );
  if (!allowUseAutocolor) {
    alert('Questa funzione non è disponibile nel tuo piano di abbonamento');
    return;
  }

  const startTime = performance.now();
  startAiLoader(AI_FEATURE_LOADING_MESSAGES.AUTOCOLOR, '✨ Correggi Colore');

  let selection = window.canvas.getActiveObject();
  if (selection.type === 'MagicFrame') {
    selection = selection.editingImg;
  }

  if (isPlaceholderEditing(selection)) {
    return;
  }

  const imageUrl = await prepareImageForEditing(selection, false);

  if (!imageUrl) {
    console.error('No image URL found in current selection', selection);
    stopAiLoader();
    return;
  }

  const httpClient = await getAxiosClient();
  const data = {
    imageUrl,
    resolution: 'full-hd',
  };

  let response;
  try {
    response = await httpClient.post(
      `${process.env.GIOTTO_API_URL}/colorize`,
      data
    );
  } catch (err) {
    console.error(err);
    stopAiLoader();
    return onErrorShowMessage();
  }

  stopAiLoader();

  // Show approval dialog with the colorized image
  showApprovalDialog({
    images: response.data.imageUrl,
    onApprove: async (approvedImageUrl) => {
      const attachmentsUploader = getState('uploader.allegati');
      attachmentsUploader.cancelAll();

      await onCompleteAttachment({
        successful: [
          {
            name: 'AutoColor',
            uploadURL: approvedImageUrl,
            type: response.data.contentType,
            size: 0,
            customAttachmentProps: {
              rawImage: imageUrl,
              isAutoColor: true,
            },
          },
        ],
      });

      let magicFrame = selection._magicFrame;
      if (selection.type === 'MagicFrame') {
        magicFrame = selection;
      }

      if (magicFrame) {
        await magicFrame.updatePerson(approvedImageUrl);
        magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
        magicFrame.scalePersonToWidth(magicFrame.width * magicFrame.scaleX);
      } else {
        const currentProps = {
          scaleX: selection.scaleX,
          scaleY: selection.scaleY,
          top: selection.top,
          left: selection.left,
        };

        await changeImageSrc(selection, approvedImageUrl);

        selection.set({
          ...currentProps,
        });
      }
      window.canvas.renderAll();
      triggerStateChangedRequest();

      // Show success message
      showAiSuccessMessage(
        'Colori Migliorati',
        'I colori sono stati ottimizzati con successo!'
      );

      trackEvent('AI AutoColor', {
        success: true,
        time_taken: parseInt(performance.now() - startTime, 10),
      });
    },
  });
}
